import { Form, Select } from 'antd';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { Box } from '@/components/Utils';
import { RULES } from '@/constants';
import { useUniStudyBranchesOptions } from '@/hooks';
interface BranchSelectProps {
  onChange?: (value: string) => void;
}
export const UserInfoBranchSelector: React.FC<BranchSelectProps> = ({ onChange }) => {
  const { getBranchOptions } = useUniStudyBranchesOptions();
  const options = useMemo(() => getBranchOptions(), [getBranchOptions]);
  const { t } = useTranslation('StudentOnboardingPageTranslations');

  return (
    <Box flexDirection="column" gap={12}>
      <Form.Item name="studyBranch" rules={[RULES.REQUIRED]}>
        <Select options={options} placeholder={t('SELECT_BRANCH')} onChange={onChange} />
      </Form.Item>
    </Box>
  );
};
